/* Divine Leaf premium homepage — small, dependency-free behaviours.
   Hero carousel (swipe via native scroll-snap, dots, counter, autoplay),
   Diwali countdown, and fade-up reveal. Re-inits inside the Theme Editor. */
(function () {
  'use strict';
  if (window.__dlHomeLoaded) return; /* every dl- section includes this file; run once */
  window.__dlHomeLoaded = true;
  document.documentElement.classList.add('dl-js');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initHero(root) {
    if (!root || root.__dlHero) return;
    root.__dlHero = true;
    var track = root.querySelector('[data-dl-track]');
    var slides = root.querySelectorAll('[data-dl-slide]');
    var dots = root.querySelectorAll('[data-dl-dot]');
    var counter = root.querySelector('[data-dl-counter]');
    if (!track || slides.length === 0) return;
    var index = 0;
    var timer = null;
    var delay = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 0;

    function render(i) {
      index = i;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); s.toggleAttribute('inert', k !== i); });
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(slides.length);
    }
    function go(i) {
      var n = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      render(n);
    }
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && i >= 0 && i < slides.length) render(i);
      });
    }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(index + 1); restart(); }
      if (e.key === 'ArrowLeft') { go(index - 1); restart(); }
    });

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (!delay || reduceMotion || slides.length < 2 || timer) return;
      timer = setInterval(function () { go(index + 1); }, delay);
    }
    function restart() { stop(); start(); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    track.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    render(0);
    start();
    root.__dlStop = stop;
  }

  function initCountdown(el) {
    var target = el.getAttribute('data-date');
    if (!target) return;
    var t = new Date(target + 'T00:00:00+05:30').getTime();
    if (isNaN(t)) return;
    var days = Math.max(0, Math.ceil((t - Date.now()) / 86400000));
    var out = el.querySelector('[data-dl-days]');
    if (out) out.textContent = days;
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-dl-hero]').forEach(initHero);
    scope.querySelectorAll('[data-dl-countdown]').forEach(initCountdown);
    scope.querySelectorAll('.dl-reveal').forEach(function (el) {
      if (!io || reduceMotion || (window.Shopify && window.Shopify.designMode)) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var h = e.target.querySelector('[data-dl-hero]');
    if (h && h.__dlStop) h.__dlStop();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-dl-slide]');
    var hero = e.target.closest('[data-dl-hero]');
    if (slide && hero) {
      if (hero.__dlStop) hero.__dlStop();
      var track = hero.querySelector('[data-dl-track]');
      track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
    }
  });
})();
